import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { HighlightColor, HighlightRange, IDateRange } from "components/dashboard/product-template-table/utils/interfaces";
import { ChronoUnitLegacy } from "utils/time-utils";
import { ReportOptions } from "./component-print-models";
import { DashboardComponentPropsBase, IComponentTimed } from "../components/pages/dashboard/components/interfaces";


export type DatasetDataInfo = DatasetDataInfoResponse & {
    loadedTime: Date
}

export interface DatasetFullDefaultConfig extends DashboardComponentPropsBase<ReportOptions>, IComponentTimed, IDateRange {
    highlightRanges?: Array<HighlightRange>
    config?: ComponentConfigDefault;
    datasets?: Array<DatasetDefaultConfig>;
    mode?: DatasetTableMode;
    hideHeader?: boolean;
    hideRefresh?: boolean
}

export type DatasetTableMode = "SINGLE" | "GROUPED"


export interface TimeConfigDefaultDefined {
    alignStartTo: ChronoUnitLegacy,
    startOffsetUnits: ChronoUnitLegacy,
    startOffset: number,
    lagUnits: ChronoUnitLegacy,
    lagOffset: number,
    leadUnits: ChronoUnitLegacy,
    leadOffset: number
}

export interface ComponentConfigDefault {
    alignStartTo?: ChronoUnitLegacy,
    startOffsetUnits?: ChronoUnitLegacy,
    startOffset?: number,
    lagUnits?: ChronoUnitLegacy,
    lagOffset?: number,
    leadUnits?: ChronoUnitLegacy,
    leadOffset?: number,

    stepUnits?: ChronoUnitLegacy,
    stepSize?: number,

    startAutoRefreshFrequency?: number

    dateFormat?: ChronoUnitLegacy;

    sort?: "ASC" | "DESC";
    itemsPerPage?: number;
    transposed?: boolean;
    showEmpty?: boolean;
    showTotal?: boolean;
    hidePagination?: boolean;
    totalType?: "SUM" | "AVG";
    totalSize?: "PAGE" | "ALL";

    hideDateColumn?: boolean;
}

export interface DatasetDefaultConfig {
    overriddenTitle?: string;
    description?: string;
    identifier: string;
    decimalPlaces?: number;
    highlightRanges?: Array<HighlightRange>
    defaultHighlight?: HighlightColor
    showTotal?: boolean;
    unit?: string;
    title?: string;
    totalType?: "SUM" | "AVG";
}

export interface DatasetOverrideTitleConfig {
    overriddenTitle?: string;
    description?: string;
    title: string;
    unit?: string;
    identifier: string;
    highlightRanges?: Array<HighlightRange>
    defaultHighlight?: HighlightColor
}

export interface HighlightMapped {
    identifier: string;
    highlightRanges?: Array<HighlightRange>
    defaultHighlight?: HighlightColor
}

export interface IPair {
    key: string;
    value: any;
}

export const mapDatasetDataInfoResponseToDatasetDataInfo = (dataset: DatasetDataInfoResponse) => {
    return {...dataset, loadedTime: new Date()} as DatasetDataInfo
}